<template>
    <BreadCrumb PageTitle=" Importation des contrats" />
      <ImportationFichierPlace />
    </template>
    
    <script lang="ts">
      import { defineComponent } from "vue";
      import BreadCrumb from "../../components/Common/BreadCrumb.vue";  
      import ImportationFichierPlace from "@/components/Importation/ImportationFichierPlace.vue";
  
    
      export default defineComponent({
        name: "ImportationContratPage",
        components: {
            ImportationFichierPlace,
        },
      });
    </script>